namespace appn.views.repositoryAdmin.index {

    class InitArgs {
        isShowClientInstall: boolean = false;
        repositoryAdminCreate: string = emptyString;
    }

    let _initArgs: InitArgs;

    export let selectedItems: any;
    let _dataTable: any = null;
    let _filter = appn.emptyString;

    export function init(args: InitArgs): void {
        _initArgs = args;

        addEvents();
        createDataTable();
    }

    function addEvents() {
        $('.folderchange').click(function(e) {
            e.preventDefault();

            $('.folder').removeClass('active');
            $(this).parents('.folder').addClass('active');

            appn.dataTable.uncheckAllRowsBox();

            // Get Id and redraw datatable
            _filter = $(this)[0].id;
            _dataTable.fnDraw(false);
        });
    }

    function createDataTable() {
        
        _dataTable = appn.dataTable.create('.dataTable', {
            aaSorting: [[1, 'asc']],
            sAjaxSource: 'RepositoryAdmin/DataTable',
            fnServerData: function(data: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')),
                    appn.dataTable.getStateOrDefault('sCustom_1', _filter));
            },
            aoColumns: getDtColConfiguration(),
            fnInitComplete: function() {

                // Inject Screen Action buttons
                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'installBtn', buttonType: 'ManageInstalls', isDataTableToggleBtn: true }
                ], _initArgs.isShowClientInstall, true);

                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'addnew', buttonType: 'AddNew' }
                ], appn.requestUser.isAdminOrHigher);

                $('#addnew').click(function(e) {
                    e.preventDefault();
                    appn.location.navTo(_initArgs.repositoryAdminCreate);
                });

                // Prpend the show button
                appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));

                // Bind install button
                $('#installBtn').click(function() {
                    if ($(this).css('opacity') === '1') {
                        // Set selectedItems
                        selectedItems = $('.selectRow:checked');
                        appn.iframe.openModal({ url: 'RepositoryAdmin/Install/' })
                            .then(function($modal: any) {
                                $modal.on('hidden.bs.modal', function() {
                                    appn.notifications.updateNotificationTotal();
                                });
                            });
                    }
                });

                appn.dataTable.addSearchPlaceholder(T('Filter results where the Repository Items <b>Name, Type or Category</b> contains a keyword typed in here.'));

                appn.saveMeState.init(function() {
                    _dataTable.fnDraw(false);
                },
                    function() {
                        _dataTable.fnDraw(false);
                    }, '.dataTables_filter');
            }
        });
    }

    function getDtColConfiguration(): Array<IDTColumns> {
        switch (_initArgs.isShowClientInstall) {
            case true: {
                return [
                    { bSortable: false, sWidth: '3%' },
                    { bSortable: true, sWidth: '50%' },
                    { bSortable: true, sWidth: '20%' },
                    { bSortable: true, sWidth: '10%' },
                    { bSortable: true, sWidth: '15%' }
                ] as Array<IDTColumns>;
            }
            default: {
                return [
                    { bSortable: false, sWidth: '0%' },
                    { bSortable: true, sWidth: '55%' },
                    { bSortable: true, sWidth: '20%' },
                    { bSortable: true, sWidth: '10%' },
                    { bSortable: true, sWidth: '15%' }
                ] as Array<IDTColumns>;
            }
        }
    }
}
